import { API, standardResponse } from "./middleware";

export async function searchCategorys(dataSearch) {
  return API.post("api/category/searchCategorys", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function fetchCategoryCreate(data) {
  return API.post("/api/category/create", data)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchCategoryUpdate(id, data) {
  return API.put(`/api/category/update/${id}`, data)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchCategoryToggleStatus(id) {
  return API.put(`/api/category/changeStatus/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchCategoryDelete(id) {
  return API.delete(`/api/category/delete/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchCategoryOptions() {
  return API.get("/api/public/category/getOptions")
    .then((res) => res.data?.object || [])
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error("Lỗi khi load danh mục:", err);
      return [];
    });
}
